<template>
  <div class="page-wrap" style="text-align: right">
    <Page
      :total="pageInfo.total"
      :page-size="pageInfo.pageSize"
      show-total
      show-elevator
      show-sizer
      :current="pageInfo.pageNum"
      class="page-right"
      :page-size-opts="pageSizeOpts"
      @on-page-size-change="onPageSizeChange"
      @on-change="handlePageChange"
    ></Page>
  </div>
</template>

<script>
import { getColumn } from '../data/SettlementTable';
export default {
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableType: this.$route.meta.tableType,
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0

      }
    };
  },
  watch: {
    total(newVal, oldVal) {
      this.pageInfo.total = newVal;
    }
  },
  methods: {
    handlePageChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.$emit('on-page-change', this.pageInfo);
    },
    // 页码 大小改变
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.$emit('on-page-change', this.pageInfo);
    },
    init() {
      this.pageInfo.pageNum = 1;
    }
  }

};
</script>

<style>
</style>
